module.exports = __webpack_public_path__ + "img/Card_spade_5.1711ed2d.svg";